<!--
TODO: What is the principle of alerts controller that could not be included in alerts store through
reacting to lifecycle events? What should go in here vs what should go in Store is hard to determine.
-->

<script type="text/javascript">
	import moment from "moment";
	import { onDestroy,onMount } from "svelte";
	import { get } from 'svelte/store';

	import AuthStore from '../Auth/Store';
	import LoadState from "../Enums/LoadState";
	import MapStore from '../Map/Store';
	import InfoCardStore from '../UI/InfoCard/Store';
	import AlertsStore from './Store';

	import MapLayer from '../Map/Enums/MapLayer';
	import VesselProperty from '../Models/Enums/VesselProperty';

	import Feature from "../Branding/Feature";
	import User from "../Branding/User";

	import AlertFilters from "../UI/AlertFilters/AlertFilters.svelte";
	import AlertList from "../UI/AlertList/AlertList.svelte";
	import ExportForm from "../UI/ExportForm/ExportForm.svelte";
	import LastUpdated from "../UI/FlyoutMenu/LastUpdated.svelte";
	import TimeSlider from "../UI/TimeSlider/TimeSlider.svelte";

	import LoadingStore from "../LoadingStore";
	import VesselKeyComponent from "../UI/Key/VesselKeyComponent.svelte";

	let fetchDataInterval = null;
	let loadState = AlertsStore.meta.loadState;

	let hasHistoricData = AlertsStore.meta.hasHistoricData;

	onMount(() => {
		AlertsStore.actions.initMap(MapStore.helpers.getMap());

		AlertsStore.vesselGroup.uniqidType = VesselProperty.MMSI;
		AlertsStore.vesselGroup.vessels.subscribe(() => {
			// TODO: consider only loading layers on map load AND is logged in. somewhere else.
			if (AuthStore.helpers.isLoggedIn()) {
				AlertsStore.actions.updateMapSources();
			}
		});
		AlertsStore.vesselGroup.onFocusedChanged.add((vessels) => {
			// TODO: If we have to have a focus event / magnifying glass button on other lists, consider moving into Vessel Group.
			if (vessels.length > 0) {
				// console.log("focus changed -- vessels", vessels);
				InfoCardStore.actions.setModel(vessels[vessels.length-1]);
				MapStore.helpers.zoomToPoint(vessels[vessels.length-1].currentCoordinates);
			}
		});

		let cachedIconMode = null;
		AlertsStore.iconMode.subscribe((iconMode) => {
			if (AuthStore.helpers.isLoggedIn()) {
				if (iconMode !== cachedIconMode) {
					cachedIconMode = iconMode;
					const liveVessels = get(AlertsStore.vesselGroup.vessels);
					if (liveVessels) {
						liveVessels.forEach(vessel => vessel.setIconMode(cachedIconMode));
						AlertsStore.actions.updateMapSources();
					}
				}
			}
		});

		let cachedSnapshotDate = null;
		AlertsStore.vesselGroup.timeSliderData.value.subscribe((value) => {
			//console.log("AlertsStore.vesselGroup.timeSliderData.value", value, cachedSnapshotDate);
			if (AuthStore.helpers.isLoggedIn()) {
				if (cachedSnapshotDate !== value) {
					cachedSnapshotDate = value;
					const liveVessels = get(AlertsStore.vesselGroup.vessels);
					if(liveVessels){
						liveVessels.forEach(vessel => vessel.updateSnapshot(value));
						AlertsStore.actions.updateMapSources();
					}
				}
			}
		});
		const updateTimeSliderSubscription = AlertsStore.meta.lastUpdated.subscribe((lastUpdated)=>{
			const updateDateToLast7Days = (now) => {
				const oldMax = get(AlertsStore.vesselGroup.timeSliderData.max);
				const oldVal = get(AlertsStore.vesselGroup.timeSliderData.value);
				let maxDate = moment(now);
				let minDate = moment(now).subtract(7, 'days');

				if (moment(oldVal).isBefore(minDate)) {
					AlertsStore.vesselGroup.timeSliderData.value.set(minDate);
				} else {
					// This is to trigger an update to the slider position, could be more efficient...
					AlertsStore.vesselGroup.timeSliderData.value.update((val) => { return val; });
				}

				// If the alerts data updates and we're at the most recent point, keep us at the most recent point.
				if (oldVal == oldMax) {
					AlertsStore.vesselGroup.timeSliderData.value.set(maxDate);
				}

				AlertsStore.vesselGroup.timeSliderData.min.set(minDate);
				AlertsStore.vesselGroup.timeSliderData.max.set(maxDate);
				//console.log("updateDateToLast7Days", minDate, maxDate);
			};
			if (lastUpdated.getTime() !== 0) {
				updateDateToLast7Days(lastUpdated);
			}
		});

		// Set up the map input handler/s.
		MapStore.meta.initialised.subscribe((initialised)=>{
			if (initialised) {
				const map = MapStore.helpers.getMap();
				map.on("click", MapLayer.VESSELS_LIVE, event => {
					event.preventDefault();

					AlertsStore.vesselGroup.selectSingle(map, event, [MapLayer.VESSELS_LIVE], [VesselProperty.MMSI]);
				});

				map.on("click", MapLayer.VESSELS_HISTORY_POINTS, event => {
					event.preventDefault();
					let features = map.queryRenderedFeatures(event.point, {
						layers: [MapLayer.VESSELS_HISTORY_POINTS]
					});
					if (features.length) {
						const feature = features[0];
						const featureTimeStamp = feature.properties[VesselProperty.TIMESTAMP]
						if(featureTimeStamp) {
							AlertsStore.vesselGroup.timeSliderData.value.set(moment(new Date(featureTimeStamp)));
						}
					}
				});
			}
		});
		MapStore.meta.initialised.subscribe((initialised)=>{
			//console.log("MapStore.meta.initialised", initialised);
			if (initialised && $loadState === LoadState.INIT) {
				// Refresh alert data every 5 minutes
				if (User.hasFeature(Feature.ALERTS.VIEW)) {
					AlertsStore.actions.loadNewRemoteData();
					fetchDataInterval = setInterval(AlertsStore.actions.loadNewRemoteData, 60 * 1000 * 5);
				}
			}
		});
		// These serves AlertsStore.actions.updateMapSources
		MapStore.meta.initialised.subscribe((isInitialised) => {
			if (isInitialised) {
				AlertsStore._localCaches.mapReady = true;
				AlertsStore.actions.updateMapSources();
			}
		});

		LoadingStore.add("alerts", loadState);
		return () => {
			LoadingStore.remove("alerts");

			if (updateTimeSliderSubscription) {
				updateTimeSliderSubscription();
			}
			if (fetchDataInterval) {
				clearInterval(fetchDataInterval);
			}
		};
	});

	onDestroy(()=>{
		AlertsStore.actions.deinitMap();
	});
</script>

<!-- <LayerList /> -->
<AlertFilters />
<AlertList />
{#if User.hasFeature(Feature.TIME_SLIDER.VIEW) && $hasHistoricData }
	<TimeSlider data={AlertsStore.vesselGroup.timeSliderData} />
{/if}
<VesselKeyComponent canHaveRimKey={true} />
<ExportForm />
<LastUpdated />
